/** Display a collection source without changing its stored identifier. */
export function sourceLabel(provider: string, name: string): string {
  if (provider !== "reddit" || !name || name === "—") return name;
  return `r/${name.replace(/^(?:r\/)+/i, "")}`;
}
